<script setup>
import { onMounted } from 'vue';
import Footer from '@/components/Footer.vue';
import BlockMbox from '@/components/BlockMbox.vue';

onMounted(async () => {
  document.title = "Thanks from Edoki Montessori Preschool";
});
</script>

<template>
  <div class="app-layout">
    <BlockMbox />
    <Footer :logo-path="'AVosKids_logo.jpg'" class="avoskids-footer" />
  </div>
</template>

<style lang="scss">
@import "@/assets/main.scss";

.app-layout {
  display: grid;
  grid-template-rows: 100fr auto;
  font-family: 'Raleway', sans-serif;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.avoskids-footer>.footer__logo>img {
  width: 7rem;
}
</style>
